import React from 'react';
import { Link } from 'react-router-dom';

// Section de contenu riche pour le référencement (matériel dentaire Algérie)
const SeoIntro = () => (
  <section className="bg-[#FAF7F2] border-t border-[#E8E0D0]">
    <div className="max-w-5xl mx-auto px-4 py-12 prose prose-sm">
      <h2 className="font-serif text-2xl font-semibold text-[#1F4D3F] mb-4">
        Comptoir Online — La marketplace du matériel dentaire en Algérie
      </h2>
      <div className="text-[#5A5247] space-y-4 text-sm leading-relaxed">
        <p>
          <strong>Comptoir Online</strong> est la première plateforme algérienne dédiée à l'achat de
          <strong> matériel dentaire</strong>. Notre objectif est simple : rendre l'achat de produits dentaires
          plus <strong>transparent, rapide et économique</strong> pour tous les chirurgiens-dentistes, prothésistes
          et cabinets dentaires d'Algérie.
        </p>
        <p>
          Sur Comptoir Online, vous pouvez <strong>comparer les prix</strong> de centaines de produits dentaires
          proposés par différents <strong>fournisseurs dentaires algériens</strong> vérifiés. Fini les appels
          téléphoniques à répétition et l'attente du passage du commercial : trouvez le meilleur prix,
          commandez en ligne et recevez votre matériel directement.
        </p>
        <p>
          Notre catalogue couvre l'ensemble des besoins d'un cabinet dentaire moderne :
          <strong> consommables dentaires</strong>, instruments, <strong>implants dentaires</strong>,
          matériel de prothèse, produits d'endodontie, anesthésiques, matériel d'orthodontie,
          équipements et <strong>solutions CAD/CAM</strong>. Chaque produit est proposé par des fournisseurs
          locaux, avec des prix affichés clairement et la possibilité de comparer les offres en un coup d'œil.
        </p>
        <p>
          Que vous cherchiez à <strong>acheter du matériel dentaire pas cher en Algérie</strong>, à comparer
          les prix entre fournisseurs ou à découvrir de nouveaux produits, Comptoir Online vous accompagne.
          <Link to="/categories" className="text-[#1F4D3F] underline ml-1">Explorez notre catalogue</Link> ou
          <Link to="/devenir-fournisseur" className="text-[#1F4D3F] underline ml-1">devenez fournisseur partenaire</Link>.
        </p>
      </div>
    </div>
  </section>
);

export default SeoIntro;
